import { Table } from 'canoe';
import { ENDPOINTS, connectWithHammock } from 'hammock';
import moment from 'moment';
import React from 'react';

const formatDate = (timestamp: string) => {
  return moment(timestamp).format('MM/DD/YYYY [at] h:mm A');
};

type AuditEntry = {
  id: string;
  customerEmail: string;
  createdAt: string;
  hasSetToLock: boolean;
};
interface AuditHistoryProps {
  auditHistory: AuditEntry[];
}
const AuditHistoryImpl = ({ auditHistory }: AuditHistoryProps) => {
  return (
    <Table
      rows={auditHistory}
      columns={[
        {
          key: 'customerEmail',
          dataIndex: 'customerEmail',
          title: 'Email',
          colSpan: 4,
        },
        {
          key: 'hasSetToLock',
          dataIndex: 'hasSetToLock',
          title: 'Action',
          colSpan: 3,
        },
        {
          key: 'createdAt',
          dataIndex: 'createdAt',
          title: 'Email',
          colSpan: 3,
          render: (field: string) => formatDate(field),
        },
      ]}
    />
  );
};

export const AuditHistory = connectWithHammock(({ contentId }) => ({
  endpoint: ENDPOINTS.entityPermissionAudit,
  query: { finder: 'byResourceInfo', resourceType: 'Content', resourceId: contentId },
  resourceName: 'auditHistory',
}))(AuditHistoryImpl);
